import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Cube } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharePage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/share/${token}`)
      .then((r) => setData(r.data))
      .catch(() => setError("This link has expired."));
  }, [token]);

  return (
    <div className="grain min-h-screen">
      <header className="border-b border-zinc-800 px-6 py-5">
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-indigo-500 text-white">
            <Cube size={20} weight="bold" />
          </span>
          <span className="text-sm font-bold uppercase tracking-widest">
            Brioni Granite
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-10" data-testid="share-page">
        {error && <p className="text-sm text-zinc-400">{error}</p>}
        {data && (
          <>
            <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
              {data.customer_name
                ? `${data.customer_name} — your finished project`
                : "Your finished project"}
            </h1>
            {data.message && (
              <p className="mt-3 max-w-2xl text-sm text-zinc-400">
                {data.message}
              </p>
            )}
            <p
              className="mt-2 text-xs uppercase tracking-widest text-zinc-600"
              data-testid="share-count"
            >
              {data.photos.length} photo{data.photos.length === 1 ? "" : "s"}
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {data.photos.map((p) => (
                <figure
                  key={p.id}
                  data-testid={`share-photo-${p.id}`}
                  className="overflow-hidden rounded-lg border border-zinc-800 bg-zinc-900"
                >
                  <img
                    src={`${API}/share/${token}/photos/${p.id}`}
                    alt={p.slab_color}
                    className="h-64 w-full object-cover"
                  />
                  <figcaption className="p-4">
                    <div className="text-sm font-bold">
                      {p.slab_color || "Install"}
                    </div>
                    {p.description && (
                      <p className="mt-1 text-xs text-zinc-400">
                        {p.description}
                      </p>
                    )}
                  </figcaption>
                </figure>
              ))}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
